import { RequestDetailsQuery } from './RequestDetails.query';

export const RequestDetails = () => {
  return <RequestDetailsQuery />;
};
